import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlashMessagesComponent } from './flash-messages.component';

@NgModule({
  declarations: [FlashMessagesComponent],
  imports: [CommonModule],
  exports: [FlashMessagesComponent],
})
export class FlashMessagesModule { }
